import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAtomValue } from 'jotai';

import { userInfoAtom } from '@/interfaces/member';

import NoAuthTemplates from '@/templates/NoAuthTemplates';
import MainTemplates from '@/templates/MainTemplates';

import Login from '@/components/login';
import SignUp from '@/components/sign-up';
import Pricing from '@/components/common/Pricing';
import RefundPolicy from '@/components/common/RefundPolicy';

import Home from '@/components/home';

import Devices from '@/components/devices';
import DeviceAdd from '@/components/devices/DeviceAdd';
import Projects from '@/components/projects';
import EndorsementManagement from '@/components/fda/EndorsementManagement';
import ElectronicSignature from '@/components/fda/ElectronicSignature';
import AlarmHistory from '@/components/alarm-history';
import OperationLog from '@/components/operation-log';
import Reports from '@/components/reports';

import Users from '@/components/setting/users';
import Members from '@/components/setting/members';
import Groups from '@/components/setting/groups';
import Subscription from '@/components/setting/subscription';

const staticPathnames = ['/pricing', '/refund-policy'];

export default function MainContainer() {
  const [target, setTarget] = useState(<></>);
  const { data: userData, isLoading } = useAtomValue(userInfoAtom);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (staticPathnames.includes(pathname)) {
      switch (pathname) {
        case '/pricing':
          setTarget(<Pricing />);
          break;
        case '/refund-policy':
          setTarget(<RefundPolicy />);
          break;
      }
    } else if (userData) {
      if (userData.isAdmin) {
        navigate('/admin');
      } else {
        switch (pathname) {
          case '/':
          case '/login':
            navigate('/home', { replace: true });
            break;
          case '/home':
            setTarget(<Home />);
            break;
          case '/devices':
            setTarget(<Devices />);
            break;
          case '/projects':
            setTarget(<Projects />);
            break;
          case '/fda/endorsement':
            setTarget(<EndorsementManagement />);
            break;
          case '/fda/signature':
            setTarget(<ElectronicSignature />);
            break;
          case '/alarm-history':
            setTarget(<AlarmHistory />);
            break;
          case '/operation-log':
            setTarget(<OperationLog />);
            break;
          case '/reports':
            setTarget(<Reports />);
            break;
          case '/setting/users':
            setTarget(<Users />);
            break;
          case '/setting/members':
            setTarget(<Members />);
            break;
          case '/setting/groups':
            setTarget(<Groups />);
            break;
          case '/setting/subscription':
            setTarget(<Subscription />);
            break;
          default:
            setTarget(<></>);
            break;
        }
      }
    } else {
      switch (pathname) {
        case '/sign-up':
          setTarget(<SignUp />);
          break;
        default:
          pathname !== '/login' && navigate('/login', { replace: false });
          setTarget(<Login />);
          break;
      }
    }
  }, [isLoading, pathname, navigate, userData]);

  if (isLoading) return <></>;
  if (!userData || staticPathnames.includes(pathname)) return <NoAuthTemplates>{target}</NoAuthTemplates>;
  return (
    <MainTemplates>
      {target}
      <DeviceAdd />
    </MainTemplates>
  );
}
